import { useState } from 'react';
import GreenCheckIcon from '@/../assets/green-check.svg?react';
import { ToggleField } from '@brighte/form-components';
import { SelectionCardTitle } from '@components/SelectionCard';
import { SelectionConfirmationButton } from '@components/SelectionCard/SelectionCard';
import { Box } from '@spark-web/box';
import { Columns } from '@spark-web/columns';
import { RadioCard, RadioGroup } from '@spark-web/radio';
import { OPEN_BANKING_INCOME_DETAILS } from '../../utils/constants';

interface EditConfirmationProps {
  onChange: (value: boolean) => void;
  confirmation?: boolean;
}

export default function EditConfirmation({ onChange }: EditConfirmationProps) {
  const { INCOME_LOOKS_CORRECT, YES, NO } = OPEN_BANKING_INCOME_DETAILS;
  const [selected, setSelected] = useState<'true' | 'false' | ''>('');

  const handleChange = (value: 'true' | 'false' | '') => {
    setSelected(value);
    if (value !== '') {
      onChange(value === 'true' ? true : false);
    }
  };

  return (
    <>
      <Box display="flex" paddingTop="xsmall">
        <SelectionCardTitle>{INCOME_LOOKS_CORRECT}</SelectionCardTitle>
      </Box>
      <Box display="flex" gap="medium">
        <RadioGroup<'true' | 'false' | ''> value={selected} onChange={handleChange}>
          <Box flex={1}>
            <Columns gap="large" collapseBelow="tablet">
              <RadioCard value="true">{YES}</RadioCard>
              <RadioCard value="false">{NO}</RadioCard>
            </Columns>
          </Box>
        </RadioGroup>
      </Box>
    </>
  );
}
